import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {    
  faCheck,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'


class Certimail extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 0 0 50px 0;
            .heading {
              width: 100%;
            }          
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }            
        `

        const ServiceRow = styled(Row)`
            margin-top: 10px;
        `
        const ServiceRow1 = styled(Row)`
            margin-top: 50px;
        `
         
         const TecText = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #808080;
            margin-bottom: 50px;            
        `

        const ResponsiveTable = styled.table`
          width: 100%;
          margin-bottom: 1.5em;
          border-spacing: 0;
          
          thead {
            // Accessibly hide <thead> on narrow viewports
            position: absolute;
            clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
            padding: 0;
            border: 0;
            height: 1px; 
            width: 1px; 
            overflow: hidden;
            
            @media (min-width: 48em) {
              // Unhide <thead> on wide viewports
              position: relative;
              clip: auto;
              height: auto;
              width: auto;
              overflow: auto;
            }
            
            th {
              background-color: rgba(104,104,104,1);              
              font-weight: normal;
              text-align: left;
              color: white;
              
              &:first-of-type {
                text-align: left; 
              }
            }
          }

          td:first-child {
            background-color: #ddd; /* Color para la primera columna */
          }

          td:nth-child(2),
          td:nth-child(4) {
            background-color: #f2f2f2; /* Color para la tercera y cuarta columna */
          }

          td:nth-child(3) {
            background-color: #164f76; /* Color para la tercera y cuarta columna */
            color: #fff;
            @media (max-width:767px) {
              color: #fff;
            }
          }
          
          // Set these items to display: block for narrow viewports
          tbody,
          tr,
          th,
          td {
            display: block;
            padding: 0;
            text-align: left;
            white-space: normal;
          }
          
          tr {   
            @media (min-width: 48em) {
              // Undo display: block 
              display: table-row; 
            }
          }
          
          th,
          td {
            padding: .5em;
            vertical-align: middle;
            
            @media (min-width: 30em) {
              padding: .75em .5em; 
            }
            
            @media (min-width: 48em) {
              // Undo display: block 
              display: table-cell;
              padding: .5em;
            }
            
            @media (min-width: 62em) {
              padding: .75em .5em; 
            }
            
            @media (min-width: 75em) {
              padding: .75em; 
            }
          }
          
          caption {
            margin-bottom: 1em;
            font-size: 1em;
            font-weight: bold;
            text-align: center;
            
            @media (min-width: 48em) {
              font-size: 1.5em;
            }
          }
          
          tfoot {
            font-size: .8em;
            font-style: italic;
            
            @media (min-width: 62em) {
              font-size: .9em;
            }
          }
          
          tbody {
            @media (min-width: 48em) {
              // Undo display: block 
              display: table-row-group; 
            }
            
            tr {
              margin-bottom: 1em;
              border-left: none; /* Elimina el borde izquierdo */
              border-right: none; /* Elimina el borde derecho */
              @media (min-width: 48em) {
                // Undo display: block 
                display: table-row;
                border-width: 1px;
              }
              
              &:last-of-type {
                margin-bottom: 0; 
              }
              
              &:nth-of-type(even) {
                @media (min-width: 48em) {
                  background-color: rgba(0,0,0,.12);
                }
              }
            }
            
            th[scope="row"] {
              
              color: white;
              border-left: none;              
              border-bottom: 1px solid #242424;
              @media (min-width: 48em) {
                background-color: transparent;
                color: rgba(0,0,0.87);
                text-align: left;
              }
            }
            
            td {
              text-align: right;
              border-bottom: 1px solid #242424;
              @media (min-width: 48em) {                
                text-align: left; 
              }              
              
            }
            
            td[data-type=currency] {
              text-align: right; 
            }
            
            td[data-tooltip-content]:before {
              content: attr(data-tooltip-content);
              float: left;
              font-size: .8em;
              
              font-weight: bold;
              @media (min-width: 30em) {
                font-size: .9em; 
              }
              
              @media (min-width: 48em) {
                // Don’t show data-tooltip-content labels 
                content: none; 
              }
            } 
          }          
          `

        const Badge = styled.span`
          display:inline-block;
          background-color: #164f76 !important;
          padding:.25em .4em;
          font-size:75%;
          font-weight:700;
          line-height:1;
          text-align:center;
          white-space:nowrap;
          vertical-align:baseline;
          border-radius:.10rem;
          transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
          `        

        const Color1 = styled.span`            
          font-weight: bold;
          color: #ff0000;          
        `
        
        const Color2 = styled.span`            
          font-weight: bold;
          color: #0392f6;            
        `

        const Color3 = styled.span`            
          font-weight: bold;
          color: #164f76;          
        `

        const Heading3 = styled.h3`        
        font-weight: bold;        
        @media (min-width:768px) and (max-width:1600px) {
          font-size: 16px;
          line-height: 20px;
        }
        @media (max-width:767px) {
          font-size: 15px;
          line-height: 20px;          
        }
     `

        const Heading3T = styled.h3`        
        font-size: 38px;
        font-weight: 500;
        font-family: Oswald;
        color: #0174c3;
        margin: 30px 0px 10px;
      `

        const Headinga = styled.a`        
        color: #78c91c;
        transition: .5s;
          &:hover {
          color: #000;
          text-decoration: none;
        }
      `

      const Headingab = styled.a`        
        color: #78c91c;
        transition: .5s;
          &:hover {
          color: #fff;
          text-decoration: none;
        }
      `

      const { data } = this.props;
        // Agregar verificación para asegurarse de que los datos están disponibles
        if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
            return <div>Loading...</div>;
        }
        
        const prices = data.allPricesJson.nodes[0].items;

        console.log(prices)

        return(
          <Section>
            <Container>
              <ServiceRow>
                <Col md={12}>
                  <Heading3T>
                    DigiCert S/MIME certificate
                  </Heading3T>
                  <TecText>
                    <Color3>Sin autenticación de dos factores (2FA), firma de correo electrónico y firma de documentos,</Color3> su organización es tan segura como su contraseña más débil. Los certificados
                    de cliente, también conocidos como certificados de identificación personal, se utilizan para identificar y validar concretamente a usuarios individuales. De esa manera,
                    podrá <Color3>controlar a qué puede acceder cada usuario y a qué no, y cifrar y firmar las comunicaciones que envían y reciben.</Color3>
                  </TecText>
                </Col>
              </ServiceRow>
              <ServiceRow1>
                <Col md={12}>
                  
                    <ResponsiveTable>
                      <thead>
                        <tr>
                          <th scope="col">Certificado S/MIME <Badge>DESTACADO</Badge></th>
                          <th scope="col">Clase 1</th>
                          <th scope="col">Clase 2</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td data-tooltip-content="Certificado">Período máximo</td>
                          <td data-tooltip-content="Clase 1">3 años</td>
                          <td data-tooltip-content="Clase 2">3 años</td>
                        </tr>
                        <tr>
                          <td data-tooltip-content="Certificado">Firma de documentos</td>
                          <td aria-label="Clase 1" data-tooltip-content="Clase 1"><Color1><FontAwesomeIcon icon={faTimesCircle} size="1x" /></Color1></td>
                          <td aria-label="Clase 2" data-tooltip-content="Clase 2"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2></td>
                        </tr>
                        <tr>
                          <td data-tooltip-content="Certificado">Autenticación del cliente</td>
                          <td aria-label="Clase 1" data-tooltip-content="Clase 1"><Color1><FontAwesomeIcon icon={faTimesCircle} size="1x" /></Color1></td>
                          <td aria-label="Clase 2" data-tooltip-content="Clase 2"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2></td>
                        </tr>
                        <tr>
                          <td data-tooltip-content="Certificado">Firma de correo electrónico</td>
                          <td aria-label="Clase 1" data-tooltip-content="Clase 1"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2></td>
                          <td aria-label="Clase 2" data-tooltip-content="Clase 2"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2></td>
                        </tr>
                        <tr>
                          <td data-tooltip-content="Certificado">Cifrado de correo electrónico</td>
                          <td aria-label="Clase 1" data-tooltip-content="Clase 1"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2></td>
                          <td aria-label="Clase 2" data-tooltip-content="Clase 2"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2></td>
                        </tr>
                        <tr>
                          <td data-tooltip-content="Certificado">1 año</td>
                          <td data-tooltip-content="Clase 1">${prices.find(x => x.name === 'C11').price}/año</td>
                          <td data-tooltip-content="Clase 2">${prices.find(x => x.name === 'C21').price}/año</td>
                        </tr>
                        <tr>
                          <td data-tooltip-content="Certificado">2 años</td>
                          <td data-tooltip-content="Clase 1">${prices.find(x => x.name === 'C12').price}/2 años</td>
                          <td data-tooltip-content="Clase 2">${prices.find(x => x.name === 'C22').price}/2 años</td>
                        </tr>
                        <tr>
                          <td data-tooltip-content="Certificado">3 años</td>
                          <td data-tooltip-content="Clase 1">${prices.find(x => x.name === 'C13').price}/3 años</td>
                          <td data-tooltip-content="Clase 2">${prices.find(x => x.name === 'C23').price}/3 años</td>
                        </tr>
                        <tr>
                          <td data-tooltip-content="Certificado">Comprar</td>
                          <td aria-label="Clase 1" data-tooltip-content="Clase 1">
                            <Heading3>
                              <Headinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=265">
                                Clase 1
                              </Headinga>
                            </Heading3>
                          </td>
                          <td aria-label="Clase 2" data-tooltip-content="Clase 2">
                            <Heading3>
                              <Headingab href="https://vascosolutions.com/zc/cart.php?a=add&pid=266">
                                Clase 2
                              </Headingab>
                            </Heading3>
                          </td>
                        </tr>
                      </tbody>
                    </ResponsiveTable>
                    <ReactTooltip id="tech-hosting-tooltips" place="top" type="dark" effect="float" />
                  
                </Col>
              </ServiceRow1>
            </Container>
          </Section>
        )
    }

}

export const query = graphql`
  query {
    allPricesJson(filter: { page: { eq: "Certimail" }, section: { eq: "planes" } }) {
      nodes {
        items {
          name
          price
        }
      }
    }
  }
`

const Ssl = (props) => (
    <StaticQuery
      query={query}
      render={(data) => (
        <Certimail
          data={data}
        />
      )}
    />
  )
  export default Ssl;